import { HttpClientModule } from '@angular/common/http';
import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IHttpData, STATUS } from '../../common/use-loading.model';
import { EoDropdownComponent } from '../eo-dropdown/eo-dropdown.component';
import { Country } from './country.model';
import { EoCountryDropdownService } from './eo-country-dropdown.service';

@Component({
  selector: 'eo-country-dropdown',
  templateUrl: './eo-country-dropdown.component.html',
  styleUrl: './eo-country-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoCountryDropdownComponent),
      multi: true,
    }
  ],
})
export class EoCountryDropdownComponent
  extends EoDropdownComponent<Country>
  implements OnInit, IHttpData<Country[]>
{
  @Input() override optionLabel = 'Name';
  @Input() url?: string;

  override httpData$ = this.countryService.countries$;
  override httpStatus$ = this.countryService.status$;
  override httpError$ = this.countryService.error$;

  override fetchData(): void {
    this.countryService.getCountries(this.url).subscribe();  
  }

  constructor(private countryService: EoCountryDropdownService) {
    super();
  }

  override ngOnInit(): void {
    this.fetchData();
    this.subscriptions = [...this.subscriptions, this.onHttpStatusChange()];
  }

  onHttpStatusChange() {
    return this.httpStatus$.subscribe((status) => {
      switch (status) {
        case STATUS.loading:
          this.loading = true;
          break;
        default:
          this.loading = false;
      }
    });
  }
}
